import React from 'react';
import PlusIcon from '@catalogo/ui-americanas-desktop-svg/plus-symbol-rounded.svg';
import MinusIcon from '@catalogo/ui-americanas-desktop-svg/minus.svg';
import * as Styled from './styles';

export const SelectorQuantity = props => {
  const {
    handleCurrentQty,
    handleKeyPress,
    error,
    currentQty,
    disableMinus,
    disablePlus,
    descriptionQty,
    inputRef,
    editing,
    toggleEditing,
  } = props;

  return (
    <>
      <Styled.Container $error={!!error}>
        <label>quantidade:</label>
        <Styled.Wrapper $error={!!error}>
          <Styled.MinusButton
            as="button"
            $disableMinus={disableMinus}
            onClick={handleCurrentQty(parseInt(currentQty) - 1, 'minus')}
          >
            <MinusIcon />
          </Styled.MinusButton>
          <Styled.InputQty
            type="number"
            name="selector-quantity-input"
            autoComplete="off"
            ref={inputRef}
            value={currentQty}
            disabled={!!error}
            onKeyPress={handleKeyPress}
            onChange={e => handleCurrentQty(e.target.value, 'input')()}
            onBlur={toggleEditing}
            $error={!!error}
            $editing={editing}
          />
          {!editing && (
            <Styled.InputQtyDescription onClick={toggleEditing} $error={!!error}>
              {descriptionQty}
            </Styled.InputQtyDescription>
          )}
          <Styled.PlusButton
            as="button"
            $disablePlus={disablePlus}
            onClick={handleCurrentQty(currentQty ? parseInt(currentQty) + 1 : 1, 'plus')}
          >
            <PlusIcon />
          </Styled.PlusButton>
        </Styled.Wrapper>
      </Styled.Container>
      {!!error && <Styled.ErrorMessage dangerouslySetInnerHTML={{ __html: error }} />}
    </>
  );
};

export default SelectorQuantity;
